import { DeviceConsumptionSummary } from '@eadsysteme/energyefficiencyclient-v2';
import { TranslocoService } from '@jsverse/transloco';
import { Injectable, inject } from '@angular/core';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';

@Injectable({
	providedIn: 'root',
})
export class FormulaUtilService {
	private transloco = inject(TranslocoService);
	private translocoLocale = inject(TranslocoLocaleService);

	locale: string;
	private readonly MIDDLE_DOT = String.fromCharCode(183);

	constructor() {
		const translocoLocale = this.translocoLocale;

		this.locale = translocoLocale.getLocale();
	}

	translateFormulaDescription(formulaDescription: string): string {
		if (!formulaDescription) {
			return '';
		}
		const placeholders = formulaDescription.match(/{\w+}/g);
		for (const placeholder of placeholders) {
			const replacer = this.transloco.translate('readingValueInfo.' + placeholder.replace('{', '').replace('}', ''));
			formulaDescription = formulaDescription.replace(placeholder, replacer);
		}
		if (this.locale === 'de-DE') {
			formulaDescription = formulaDescription.replaceAll('x', this.MIDDLE_DOT);
		}
		return formulaDescription;
	}

	translateFormula(data: DeviceConsumptionSummary) {
		const formulaData = data.consumptionKwhFormula;
		const numberFormat2Digits = new Intl.NumberFormat(this.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		const numberFormat3Digis = new Intl.NumberFormat(this.locale, { minimumFractionDigits: 3, maximumFractionDigits: 3 });
		const unit = data.consumptionUnit ? this.transloco.translate('enum.' + data.consumptionUnit) : '';
		let formula: string;
		if (formulaData.warmWaterTemperature) {
			formula = `${numberFormat2Digits.format(formulaData.consumption)} ${unit}  ${this.MIDDLE_DOT} (${formulaData.warmWaterTemperature} - 10) ${this.MIDDLE_DOT} ${numberFormat3Digis.format(formulaData.warmWaterVolumeFactor)} = ${numberFormat2Digits.format(formulaData.consumptionAsKwh)} kWh`;
		} else {
			formula = `${numberFormat2Digits.format(formulaData.consumption)} ${unit}`;
			if (formulaData.correctionFactor) {
				formula += ` / ${formulaData.correctionFactor}`;
			}
			if (formulaData.sensitivity) {
				formula += ` / ${formulaData.sensitivity}`;
			}
			formula += ` = ${numberFormat2Digits.format(formulaData.consumptionAsKwh)} kWh`;
		}

		return formula;
	}
}
